import { combineReducers } from 'redux';

import { clientsReducer } from './clientsReducer';
import { eventActionsReducer } from './eventActionsReducer';
import { eventsReducer } from './eventsReducer';
import { eventVideosReducer } from './eventVideosReducer';
import { participantsReducer } from './participantsReducer';
import { shopsReducer } from './shopsReducer';
import { usersReducer } from './usersReducer';
import { clientsUsersReducer } from './clients-users-reducer';
import { archivedEventsReducer } from './archivedEventsReducer';
import { archivedClientsReducer } from './archivedClientsReducer';

export const entitiesReducer = combineReducers({
  clients: clientsReducer,
  archivedClients: archivedClientsReducer,
  eventActions: eventActionsReducer,
  eventVideos: eventVideosReducer,
  events: eventsReducer,
  archivedEvents: archivedEventsReducer,
  participants: participantsReducer,
  shops: shopsReducer,
  users: usersReducer,
  clientsUsers: clientsUsersReducer,
});
